module.exports = __webpack_public_path__ + "static/img/gini-prescription.0a0282e.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/gini-prescription.svg
// module id = Eyu6
// module chunks = 1